import { createSlice, current } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import {
    checkForAlert, CheckForPaymentExists, DeleteProcedureDataFromModal, fetchFiltersData, fetchPayments, getAdjustmentCodeList, GetAdjustmentTypes, getClaimStatusAndSubStatus, getpatientClaimList, getPatientPaidClaims,
    getPatientPaymentClaimDetails, getPatientPaymentData, GetPatientPaymentPlans, getPaymentDetails, getResponibilityTypePatient, handleDeleteclaim, handleProcedureSubmit,
    handleRadioButtonChange, listInsurancePaymentData, ListPatientAppliedClaims, listPatientClaims, listPatientDropdownData, listProcedureClaims, 
    onSavePatientPayment, onSavePatientPaymentProcedure, onSavePayment, openProcedureModalWindow, postPaymentManually, reverseInsurancePaymentProcedure, searchClaimIDS, searchPayerList
} from "./asyncThunkAPI";
import { format } from "date-fns";
import i18n from "../../../../utilities/i18n";
import { checkAdjustmentCode, checkAdjustmentCodeDenialId, checkForDataChanges, checkForErrors, createJsonDataPatientPayment,
    createPatientProcedureData, createProcedureData, decimalConverter, enableMovedToCredit, generateTablePatientData,
    getSumAppliedUnApplied,
    insertAtPosition} from "./paymentDataProcessor";
import { filterDateValues } from "../../../../utilities/dateFilterCalculation";
import { setStorage } from "../../../../utilities/browserStorage";
import { PAGING_END_INDEX, POST_PAYMENT_TYPE_INSURANCE_ID, POST_PAYMENT_TYPE_PATIENT_ID } from "../../../../utilities/staticConfigs";
const paymentSlice = createSlice({
    name: 'paymentSlice',
    initialState,
    reducers: {
        /**
         * function to store updated filters
         * @param {*} state 
         * @param {*} actions 
         */
        updateFilters: (state, actions) => {
            let { value, name, type } = actions.payload;
            let trimmedValue = "";
            if (type != "date") {
                let inputFields = ["payment_from", "insurance", "provider", "hcpcs", "revenue_codes", "icd", "reference_check_number"];
                if (inputFields.includes(name)) {
                    trimmedValue = value;
                }

                state.filters = {
                    ...state.filters,
                    [name]: trimmedValue
                }

            } else {
                state.filters = {
                    ...state.filters,
                    [name]: value
                }
            }
        },

        resetFilters: (state) => {
            state.filters = initialState.filters;
            state.clearSelectedCounter=state.clearSelectedCounter+1;
            state.patientAdvanceSearchData=initialState.patientAdvanceSearchData;
            state.selectedPatient=initialState.selectedPatient;
            state.patientSelectedData=initialState.patientSelectedData;
            state.table=initialState.table;
        },

        /**
         * store payment details when table payment id click
         * @param {*} state 
         * @param {*} actions 
         */
        storePaymentDetailsTableClick: (state, actions) => {
            state.postPaymentDetails.insurancePostPayment = false;
            state.postPaymentDetails.postPaymentType = actions.payload.postPaymentType;
            state.postPaymentDetails.paymentPK = actions.payload.paymentPK;
            state.clickedFromTable = true;
            if (actions.payload.patientPaymentPost == 1) {
                state.postPaymentDetails.patientPaymentPost = actions.payload.patientPaymentPost;
                state.postPaymentDetails.patientPaymentPatientPK = actions.payload.patientPaymentPatientPK;
                state.postPaymentDetails.patientPaymentPostType = actions.payload.patientPaymentPostType;
            }
        },

        /**
         * pagination controler
         * @param {*} state 
         * @param {*} actions 
         */
        setPaginationChange: (state, actions) => {
            let { action_type, page} = actions.payload;
            let { table } = current(state);
            let { startIndex, endIndex, totalPage } = table
            if (action_type == "page_previous") {
                let previousPage = startIndex + 1 - PAGING_END_INDEX;
                state.table.activePage = previousPage;
                if (startIndex !== 0) {
                    state.table.startIndex = startIndex - PAGING_END_INDEX;
                    state.table.endIndex = endIndex - PAGING_END_INDEX;
                }
            } else if (action_type == "page_up") {
                state.table.activePage = page;
            } else {
                let nextPage = startIndex + 1 + PAGING_END_INDEX;
                if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
                    state.table.activePage = nextPage;
                    state.table.startIndex = startIndex;
                    state.table.endIndex = endIndex;
                } else {
                    state.table.activePage = nextPage;
                    state.table.startIndex = startIndex + PAGING_END_INDEX;
                    state.table.endIndex = endIndex + PAGING_END_INDEX;
                }

            }
        },
        /**
        * function used to store payment types @insurance and @payment
        * @param {*} state 
        * @param {*} actions 
        */
        setPostPaymentType: (state, actions) => {
            state.postPaymentDetails.postPaymentType = actions.payload;
            if (actions.payload === 1) {
                state.paymentPlan_status = true;
            } else {
                state.paymentPlan_status = false;
            }
        },

        /**
         * function to update selected payer details
         * @param {*} state 
         * @param {*} actions 
         */
        updatePayerDetails: (state, actions) => {
            let label = ""
            let selected = [];
            if (Array.isArray(actions.payload.e) && actions.payload.e.length > 0) {
                label = actions.payload.e[0].id;
                selected = actions.payload.e
            }
            if (actions.payload.action == "post") {
                state.insurancePaymentVariables.payer = label;
            } else {
                state.editPaymentVariables.payer = label;
            }
            state.selectedPayer = selected;
        },
        /**
         * insurance date value change
         * @param {*} state 
         * @param {*} actions 
         */
        updateDate: (state, actions) => {
            let { value, name, key } = actions.payload
            if (key !== "patientPaymentVariables") {
                state[key][name] = value
            }
            if (
                value &&
                new Date(value).getTime() > 0
            ) {

                state[key].payment_date = format(
                    value,
                    "yyyy-MM-dd"
                )
            } else {
                state[key].payment_date = ""
            }
        },

        /**
         * insurance other field value changes
         * @param {*} state 
         * @param {*} actions 
         */
        updateValueChange: (state, actions) => {
            let { name, value, key } = actions.payload;
            if (name === "selectCharge") {
                state.selectCharge = value;
                state.patientPostDetails.claimPK = "";
                state.selectClaim = "";
                state.patientClaims = {};
            } else if (name === "amount" || name === "level_adjustments") {
                let newValue = value.trim().replace(/[^0-9.]/g, '');
                newValue = newValue.replace(/^(\d*\.\d{0,2})\d*$/, '$1');
                state[key][name] = newValue;
            } else {
                if (name === "showPreview" && key === "patientPaymentVariables") {
                    let valueSet = {
                        ...state.patientPostDetails,
                        [name]: value
                    }
                    state.patientPostDetails = valueSet;
                } else if (name === "paymentAmount" && key === "patientPaymentVariables") {
                    let newValue = value.trim().replace(/[^0-9.]/g, "");
                    newValue = newValue.replace(/^(\d*\.\d{0,2})\d*$/, '$1');
                    state[key][name] = newValue;
                } else {
                    state[key][name] = value;
                }
            }
        },

        setPatientPostDetails: (state, actions) => {
            let { value, name, key } = actions.payload;
            let valueSet = {
                ...state.patientPostDetails,
                [name]: value,
            }

            if (key === "credit") {
                valueSet = {
                    ...valueSet,
                    postManually: false,
                    autoPost: false,
                }
            }
            state.patientPostDetails = valueSet;
        },


        setFormError: (state, actions) => {
            let formError = {
                ...state.form_error,
                [actions.payload.name]: actions.payload.value
            }
            state.form_error = formError;
            state.patientPostDetails.postManually = false;
            state.patientPostDetails.autoPost = false;
        },
        /**
         * create new notification
         * @param {*} state 
         * @param {*} actions 
         */
        showNotification: (state, actions) => {
            state.notifyMessage = actions.payload.message;
            state.showNotification = true;
            state.statusTag = actions.payload.tag;
        },

        /**
         * function to reset notification details
         * @param {*} state 
         */
        resetNotifyWindow: (state) => {
            state.notifyMessage = "";
            state.showNotification = false;
            state.statusTag = "";
            state.saveTriggered = false;
        },
        /**
         * show alert message 
         * @param {} state 
         * @param {*} actions 
         */
        showAlertMessage: (state, actions) => {
            state.alertMessage = actions.payload;
            state.showAlertMessage = true;
        },
        /**
         * reset alert message
         * @param {*} state 
         * @param {*} actions 
         */
        resetAlertMessage: (state) => {
            state.alertMessage = "";
            state.showAlertMessage = false;
        },


        showLoadingBar: (state, action) => {
            state.paymentPostLoading = action.payload;
        },

        /**
         * show model windows
         * @param {*} state 
         * @param {*} action 
         */
        showModalWindow: (state, action) => {
            state[action.payload.key] = action.payload.open;
            state.header = action.payload.header;
        },

        /**
         * hide model windows
         * @param {*} state 
         * @param {*} action 
         */
        hideModalWindow: (state, action) => {
            state[action.payload.key] = action.payload.open;
            state.header = ""
            state.validationError = [];
            state.searchOption = "",
                state.searchText = "";
        },
        /**
         * remove details on reset payment button click
         * @param {*} state 
         */
        resetPaymentDetails: (state) => {
            state.selectCharge = "";
            state.insurancePaymentVariables = initialState.insurancePaymentVariables;
            state.postPaymentDetaills = initialState.postPaymentDetails;
            state.selectedPayer = initialState.selectedPayer
        },

        //reset claim search variables
        resetSearchVariable: (state) => {
            state.claimSearchVariables = initialState.claimSearchVariables;
        },

        removeAdjustmentCodeList: (state, actions) => {
            state[actions.payload] = [];
        },

        /**
         * to update claim search variables
         * @param {*} state 
         * @param {*} actions 
         */
        updateClaimSearchVariables: (state, actions) => {
            state.claimSearchVariables.claim_id = actions.payload
            state.masterClaims = [];
        },

        /**To update toggle state */
        setToggleState: (state, action) => {

            let { modelPopId } = current(state);
            let { value, popValue } = action.payload;


            if (popValue == "yes") {
                state.procedureData[modelPopId].moved_to_credit = true;
            }
            state.togglePopUpState = value;
        },

        /**
         * to update procdure level field values
         */
        procedureValueChange: (state, actions) => {

            /**
             * Helper function for allowing positive or negative values with the help of REGEX.
             * @param {*} value 
             * @param {*} allowNegative 
             * @returns 
             */
            const sanitizeValue = (value, allowNegative = false) => {
                const regex = allowNegative ? /[^0-9.-]/g : /[^0-9.]/g;
                return String(value.trim())
                    .replace(regex, "") // Remove invalid characters
                    .replace(/(?!^)-/g, "") // Remove minus signs not at the start
                    .replace(/(\..*?)\./g, "$1") // Remove extra decimal points
                    .replace(/(\.\d{2})\d*/g, "$1") // Allow only two decimal places
                    .substring(0, 9); // Limit length to 9 characters
            };

            let { id, value, field } = actions.payload;
            if (field === "paid_amount") {
                value = sanitizeValue(value, true)
            } else if (field === "allowed_amount") {
                value = sanitizeValue(value, false)
            }

            state.procedureData[id] = {
                ...state.procedureData[id],
                [field]: value

            };

            if (field == "paid_by_entity") {
                let { paid_by_entity, is_primary_paid, is_secondary_paid, is_tertiary_paid } = state.procedureData[id];
                let enable_moved_to_credit = enableMovedToCredit(paid_by_entity, is_primary_paid, is_secondary_paid, is_tertiary_paid)
                state.procedureData[id] = {
                    ...state.procedureData[id],
                    enable_moved_to_credit: enable_moved_to_credit,
                    moved_to_credit: false
                };

                if(!enable_moved_to_credit){
                    state.procedureData[id] = {
                        ...state.procedureData[id],
                        moved_to_credit:false
                    };
                }
            }

            if (field == "responsibility_type") {
                state.procedureData[id] = {
                    ...state.procedureData[id],
                    "claim_status_id": null,
                    "claim_sub_status_id": null
                };
            }

            // setting claim_status_id to null if not selected
            if (!state.procedureData[id].claim_status_id) {
                state.procedureData[id].claim_status_id = null;
            }
            // setting claim_sub_status_id to null if not selected
            if (!state.procedureData[id].claim_sub_status_id) {
                state.procedureData[id].claim_sub_status_id = null;
            }
        },

        /**
         * reduc function to add adjustment code 1
         * @param {*} state 
         * @param {*} actions 
         * @returns 
         */
        addAdjustmentCode1: (state, actions) => {
            let { e, id } = actions.payload;
            let procedureCodes = [...state.procedureData[id]["adjustment_code1_data"], ...state.procedureData[id]["adjustment_code2_data"]];
            if (procedureCodes.some((item) => item.id === e[0].id)) {
                state.showNotification = true;
                state.notifyMessage = "Duplicate entry.";
                state.statusTag = "error";
                return
            }
            let adjustmentCode1Data = [...state.procedureData[id]["adjustment_code1_data"]];
            let adjustment = {
                code:e[0].label,
                dropdown_name:e[0].label,id:e[0].id,label:e[0].label
            }
            adjustmentCode1Data.push({
                ...adjustment,
                amount: adjustmentCode1Data.length === 0 ? (parseFloat((state.procedureData[id]["opening_balance"] ?? 0) - (state.procedureData[id]["allowed_amount"] ?? 0)).toFixed(2)) : 0
            });

            const adjustment1_sum = parseFloat(adjustmentCode1Data.reduce(
                (total, item) => total + (parseFloat(item?.amount).toFixed(2) || 0),
                0
            ));

            const openingBalance = parseFloat(state.procedureData[id]?.opening_balance || 0);
            const paidAmount = parseFloat(state.procedureData[id]?.paid_amount || 0);

            state.procedureData[id]["adjustment_code1_data"] = adjustmentCode1Data;
            state.procedureData[id]["closing_balance"] = parseFloat(
                ((openingBalance - paidAmount - adjustment1_sum)).toFixed(2)
            );
        },

        /**
        * reduc function to add adjustment code 1
        * @param {*} state 
        * @param {*} actions 
        * @returns 
        */
        addAdjustmentCode2: (state, actions) => {
            let { e, id } = actions.payload;
            let procedureCodes = [...state.procedureData[id]["adjustment_code1_data"], ...state.procedureData[id]["adjustment_code2_data"]];
            if (procedureCodes.some((item) => item.id === e[0].id)) {
                state.showNotification = true;
                state.notifyMessage = "Duplicate entry.";
                state.statusTag = "error";
                return
            }
            let adjustment = {
                code:e[0].label,
                dropdown_name:e[0].label,id:e[0].id,label:e[0].label,
                claim_sub_status:e[0].claim_sub_status.length>0 ? e[0].claim_sub_status : []
            }
            state.procedureData[id]["adjustment_code2_data"] = [...state.procedureData[id]["adjustment_code2_data"], { ...adjustment, amount: 0 }]
        },

        /**
         * redux function to remove adjustment codes
         * @param {*} state 
         * @param {*} actions 
         */
        removeAdjustmentCode: (state, actions) => {
            let { item, index, id, field } = actions.payload;
            const newEraAdjustments1 = [...state.procedureData[id][field]];
            newEraAdjustments1.splice(index, 1);
            state.procedureData[id][field] = newEraAdjustments1;
            if (
                (item.label === 'PR-1' || item.label === 'PR-2' || item.label === 'PR-3')
            ) {
                switch (item.label) {
                    case 'PR-1':
                        state.procedureData[id]["deductibles"] = '0.00';
                        break;
                    case 'PR-2':
                        state.procedureData[id]["co_insurance"] = '0.00';
                        break;
                    case 'PR-3':
                        state.procedureData[id]["copay"] = '0.00';
                        break;
                    default:
                        break;
                }
            } else {
                state.procedureData[id]["claim_status_id"] = null;
                state.procedureData[id]["claim_sub_status_id"] = null;
            }
        },

        RemoveProcedureDataManually: (state, actions) => {
            if (actions.payload){
                delete state.procedureData[actions.payload];
                delete state.duplicate_procedureData[actions.payload];
            }
        },

        /**
         * function to change switch value 
         * @param {*} state 
         * @param {*} action 
         */
        movedToCreditValueChange: (state, action) => {
            let { id, status } = action.payload;
            const currentStatus = status;

            const opening_balance = decimalConverter(state.procedureData[id]["opening_balance"]);
            const paid_amount = decimalConverter(state.procedureData[id]["paid_amount"]);
            const totalAdjustment1Amount = decimalConverter(state.procedureData[id].adjustment_code1_data?.reduce((total, item) => total + (Number(item?.amount) || 0), 0));
            state.procedureData[id]['moved_to_credit'] = !currentStatus;
            const calculatedClosingBalance = Number((opening_balance - paid_amount - totalAdjustment1Amount).toFixed(2));
            state.procedureData[id]['closing_balance'] = calculatedClosingBalance
        },

        /**
         * to add adjustment amount
         * @param {*} state 
         * @param {*} actions 
         */
        addAdjustmentAmount: (state, actions) => {
            let { value, adjustment, id, field } = actions.payload;
            let { procedureData } = current(state);

            let procedureRowToEdit = { ...procedureData[id] };

            let fieldArray = [...procedureRowToEdit[field]];

            let procedureIndex = fieldArray.findIndex((item) => item.id === adjustment.id);

            if (procedureIndex !== -1) {
                fieldArray[procedureIndex] = {
                    ...fieldArray[procedureIndex],
                    amount: value,
                };
            }

            procedureRowToEdit[field] = fieldArray;

            if (
                adjustment.label === 'PR-1' || adjustment.label === 'PR-2' || adjustment.label === 'PR-3'
            ) {
                switch (adjustment.label) {
                    case 'PR-1':
                        procedureRowToEdit["deductibles"] = value;
                        break;
                    case 'PR-2':
                        procedureRowToEdit["co_insurance"] = value;
                        break;
                    case 'PR-3':
                        procedureRowToEdit["copay"] = value;
                        break;
                    default:
                        break;
                }
            }
            state.procedureData[id] = procedureRowToEdit;
        },

        /**
         * adding remark codes to list
         * @param {*} state 
         * @param {*} actions 
         */
        onAddRemarkCodes: (state, actions) => {
            let { value, id } = actions.payload;
            if (value.length > 0) {
                let arrayId = [];
                let arrayCodes = [];
                value.map((item) => {
                    arrayId.push(item.id);
                    arrayCodes.push(item);
                });
                if (value) {
                    state.procedureData[id]['remark_code'] = arrayId;
                } else {
                    state.procedureData[id]['remark_code'] = [];
                }
                state.procedureData[id]['selectedRemarkCodes'] = arrayCodes;
            }
            else {
                state.procedureData[id]['remark_code'] = [];
                state.procedureData[id]['selectedRemarkCodes'] = [];
            }
        },

        openPatientModalWindow: (state, actions) => {
            state.openClaimWindow = true;
            let jsonObject = createPatientProcedureData(actions.payload);
            state.procedureData = jsonObject;
            state.claimIdOpened = actions.payload.custom_claim_id;
        },

        //search claim date

        onHandleSearchClaimDateChange: (state, actions) => {
            let data = {
                ...state.claimSearchVariables,
                [actions.payload.key]: actions.payload.value
            }
            state.claimSearchVariables = data;
        },

        //reset the dropdown list
        resetPatientDropdownSearch: (state, action) => {
            state.patientDropdown = action.payload || [];
        },

        //search value changes 
        onHandleValueChange: (state, actions) => {
            if (actions.payload.name === "selectCharge") {
                state.selectCharge = actions.payload.value
            }
            if (actions.payload.name == "searchText") {
                state.searchText = actions.payload.value;
            }
            if (actions.payload.name == "searchOption") {
                state.searchOption = actions.payload.value;
            }
        },

        //handle advance search field values
        onHandleAdvanceSearchFields: (state, actions) => {
            const { name, value } = actions.payload;

            if (name === "claim_status") {
                state.claimSearchVariables.claim_status = value;
            }
            if (name === "responsibility_type") {
                state.claimSearchVariables.responsibility_type = value;
            }
            if (name === "claim_type") {
                state.claimSearchVariables.claim_type = value;
            }
            if (name === "claim_date_type") {
                let dateRange = filterDateValues(value);
                state.claimSearchVariables.claim_date_type = value;
                state.claimSearchVariables.claim_date_of_service_from = dateRange.fromDate
                state.claimSearchVariables.claim_date_of_service_to = dateRange.toDate
            }
            if (name === "claim_submitted_date_type") {
                let dateRange = filterDateValues(value);
                state.claimSearchVariables.claim_submitted_date_type = value;
                state.claimSearchVariables.claim_submitted_date_from = dateRange.fromDate
                state.claimSearchVariables.claim_submitted_date_to = dateRange.toDate
            }
        },

        /**
         * procedure modal close
         * @param {*} state 
         */
        handleProcedureEditWindowClose: (state) => {
            state.openClaimWindow = false;
            state.procedureData = {};
            state.procedureError = initialState.procedureError;
            state.oldResponsibility = initialState.oldResponsibility;
            state.responsibility_type = initialState.responsibility_type;
            state.claimIdOpened = "";
            state.claimPaymentInfoIdOpened = "";
        },




        /**
         * Text field bluring time checkings happen here
         * @param {*} state 
         * @param {*} actions 
         */
        onFieldBlurApply: (state, actions) => {
            let { procedureData, oldResponsibility,responsibility_type,procedureError, claimStatusList } = current(state);
            let { responsibilityID, closing_balance } = checkForDataChanges(procedureData[actions.payload.id],
                actions.payload.field, oldResponsibility[actions.payload.index],responsibility_type[actions.payload.index]);                
            let errors = checkForErrors(procedureData[actions.payload.id], procedureError[actions.payload.id]);
            state.procedureError[actions.payload.id] = errors;

            if (responsibilityID !== state.procedureData[actions.payload.id].responsibility_type) {
                state.procedureData[actions.payload.id] = {
                    ...state.procedureData[actions.payload.id],
                    responsibility_type: responsibilityID,
                    closing_balance: closing_balance,
                    claim_status_id: null,
                    claim_sub_status_id: null
                }
            } else {
                state.procedureData[actions.payload.id] = {
                    ...state.procedureData[actions.payload.id],
                    responsibility_type: responsibilityID,
                    closing_balance: closing_balance,
                }
            }

            //extracting the id
            let primaryClaimStatus = claimStatusList.find(item => item.name.toLowerCase() === "Claim Denied at Primary".toLowerCase() && item?.priorities?.includes(1))?.id
            let secondaryClaimStatus = claimStatusList.find(item => item.name.toLowerCase() === "Claim Denied at Secondary".toLowerCase() && item?.priorities?.includes(2))?.id
            let TertiaryClaimStatus = claimStatusList.find(item => item.name.toLowerCase() === "Claim Denied at Tertiary".toLowerCase() && item?.priorities?.includes(3))?.id

            let codeStatus = checkAdjustmentCode(procedureData[actions.payload.id].adjustment_code2_data);
            let claimSubStatusId = checkAdjustmentCodeDenialId(procedureData[actions.payload.id].adjustment_code2_data)
            if (codeStatus == true) {
                if (primaryClaimStatus && responsibilityID == 1) {
                    state.procedureData[actions.payload.id] = {
                        ...state.procedureData[actions.payload.id],
                        claim_status_id: primaryClaimStatus,
                        claim_sub_status_id: claimSubStatusId
                    }
                }
                if (secondaryClaimStatus && responsibilityID == 2) {
                    state.procedureData[actions.payload.id] = {
                        ...state.procedureData[actions.payload.id],
                        claim_status_id: secondaryClaimStatus,
                        claim_sub_status_id: claimSubStatusId
                    }
                }
                if (TertiaryClaimStatus && responsibilityID == 3) {
                    state.procedureData[actions.payload.id] = {
                        ...state.procedureData[actions.payload.id],
                        claim_status_id: TertiaryClaimStatus,
                        claim_sub_status_id: claimSubStatusId
                    }
                }
                if (primaryClaimStatus && responsibilityID == 4) {
                    state.procedureData[actions.payload.id] = {
                        ...state.procedureData[actions.payload.id],
                        claim_status_id: primaryClaimStatus,
                        claim_sub_status_id: claimSubStatusId
                    }
                }

            }
        },

        /**
         * 
         * @param {*} state 
         */
        removeAllPaymentDetails: (state, action) => {
            state.claimList = [];
            state.procedureData = {};
            let data = {
                insurancePostPayment: false,
                postPaymentType: action.payload === "patient" ? POST_PAYMENT_TYPE_PATIENT_ID : POST_PAYMENT_TYPE_INSURANCE_ID,
                paymentPK: "",
                patientPaymentPost: false,
                patientPaymentPatientPK: "",
                patientPaymentPostType: false,
            }
            state.postPaymentDetails = data;
            state.insurancePaymentData = initialState.insurancePaymentData;
            state.claimSearchVariables = initialState.claimSearchVariables;
            state.patientPostDetails = initialState.patientPostDetails;
            state.patientPaymentVariables = initialState.patientPaymentVariables;
            state.patientAppliedProcedures = initialState.patientAppliedProcedures;
            state.patientPaymentData = initialState.patientPaymentData;
            state.patientClaims = [];
            state.tableRow = [];
            state.procedureError = initialState.procedureError;
            state.editPaymentVariables = initialState.editPaymentVariables;
            state.insurancePaymentVariables = initialState.insurancePaymentVariables;
            state.selectedPayer = [];
            state.selectedClaimVals = [];
            state.selectCharge = initialState.selectCharge;
            state.prTotal = "";
            state.error = {};
            state.clickedFromTable = false;
            state.paymentPlan_status = true;
            state.patientSelectedData = [];
            state.patientAdvanceSearchData = [];
            state.selectedPatient = "";
            state.redirectToReceipt = false;
        },
        /**show validation erros */
        validationErrorShowing: (state, actions) => {
            state.validationError = actions.payload.errors;
            state.validationErrorModal = actions.payload.open;
        },

        //eslint-disable-next-line
        handlePatientTableDataUpdate: (state, actions) => {
            state.oepn
            let { procedureData, claimIdOpened } = current(state);
            const { totalChargeEdited, totalReceiptEdited, totalBalanceEdited, totalAdjustmentsEdited, totalApplyAmount, totalClosingBalanceEdited, procedures } = generateTablePatientData(procedureData);
            state.patientClaims[claimIdOpened] = {
                ...state.patientClaims[claimIdOpened],
                totalChargeEdited: totalChargeEdited,
                totalReceiptEdited: totalReceiptEdited,
                totalBalanceEdited: totalBalanceEdited,
                totalAdjustmentsEdited: totalAdjustmentsEdited,
                totalApplyAmount: totalApplyAmount,
                totalClosingBalanceEdited: totalClosingBalanceEdited,
                procedures: procedures,
                edited: true
            }


            let sumApplied = 0;
            Object.keys(state.patientClaims).forEach(key => {
                state.patientClaims[key].procedures.forEach(element => {
                    sumApplied += parseFloat(element.apply_payment ?? 0);
                });
            });

            sumApplied = sumApplied.toFixed(2);

            state.patientPostDetails.sumApplied = sumApplied;
            state.patientPostDetails.unAppliedAmount = parseFloat(state.patientPostDetails.payment_amount) - sumApplied;
            state.openClaimWindow = false;
            state.procedureData = {};  
            state.claimIdOpened = "";
        },

        /**updateQuery */
        updateQueryDetails: (state, actions) => {
            state.searchQuery = actions.payload
        },

        removePatientClaimFromTable: (state, actions) => {
            delete state.patientClaims[actions.payload];
            state.patientClaimRemoved = true;
        },

        //edit payment detaails,
        onHandleEditPayment: (state, actions) => {
            let { value, name } = actions.payload;
            let data = {
                ...state.editPaymentVariables,
                [name]: value
            }

            if (name === 'payment_mode') {
                data = {
                    ...data,
                    ["reference_check_number"]: "",
                    ["amount"]: ""
                }
            }

            state.editPaymentVariables = data;
        },

        //on patient edit details date change done here
        onHandleEditPaymentDate: (state, actions) => {
            let { value, name } = actions.payload;
            let data = {
                ...state.editPaymentVariables,
                [name]: value
            }
            if (name == 'payment_mode') {
                data = {
                    ...data,
                    ["amount"]: "",
                    ["reference_check_number"]: "",
                }
            }

            state.editPaymentVariables = data;
        },

        //function ivoke when post payment type is changed
        onChangePostPaymentType: (state, actions) => {
            if (actions.payload === "manually") {
                if (!state.patientPostDetails.postManually) {
                    //CHECK ALL MANDATORY FIELDS ARE FILLED
                    let data = {
                        ...state.patientPostDetails,
                        postManually: !state.patientPostDetails.postManually,
                        autoPost: false
                    }
                    state.patientPostDetails = data;
                } else {
                    let data = {
                        ...state.patientPostDetails,
                        postManually: !state.patientPostDetails.postManually,
                        autoPost: false
                    }
                    state.patientPostDetails = data;
                }
            } else {
                if (!state.patientPostDetails.autoPost) {
                    //CHECK ALL MANDATORY FIELDS ARE FILLED
                    let data = {
                        ...state.patientPostDetails,
                        postManually: false,
                        autoPost: !state.patientPostDetails.autoPost
                    }
                    state.patientPostDetails = data;
                } else {
                    let data = {
                        ...state.patientPostDetails,
                        postManually: false,
                        autoPost: !state.patientPostDetails.autoPost
                    }
                    state.patientPostDetails = data;
                }
            }
        },

        //function ivoke when continue posting button is clicked 
        onContinuePosting: (state) => {
            state.selectCharge = "charges";
            state.patientPostDetails.showContinuePosting = true;
            state.patientPostDetails.showAppliedPayments = false;
            state.patientPostDetails.showPreview = true;
        },

        //function ivoke when patient payment procedure level changes
        onHandleApplyPaient: (state, actions) => {
            let responsibility_type = false
            let { value, id, field } = actions.payload;
            let data = {
                ...state.procedureData[id],
                [field]: value
            }



            let value1 = (parseFloat(data["apply_payment"] ? data["apply_payment"] : 0)) +
                parseFloat((data["apply_adjustments"] ? data["apply_adjustments"] : 0))
            let closing_balance = parseFloat(data["opening_balance"]) - value1;
            data = {
                ...data,
                ["closing_balance"]: closing_balance
            }


            if (closing_balance >= 0) {

                if (field === "apply_payment" || field === "apply_adjustments") {
                    if (closing_balance <= 0) {
                        responsibility_type = 5;
                    }
                    else {
                        responsibility_type = 4;
                    }
                    if (responsibility_type !== state.procedureData[id].responsibility_type) {
                        data = {
                            ...data,
                            ["responsibility_type"]: responsibility_type,
                            ["claim_status_id"]: null,
                            ["claim_sub_status_id"]: null
                        }
                    } else {
                        data = {
                            ...data,
                            ["responsibility_type"]: responsibility_type,
                        }
                    }
                }
                if (field === "claim_status_id") {
                    data["claim_status_id"] = value === "" ? null : value;
                }

                // Handle claim_sub_status_id field
                if (field === "claim_sub_status_id") {
                    data["claim_sub_status_id"] = value === "" ? null : value;
                }


                state.procedureData[id] = data
            } else {
                state.showNotification = true;
                state.notifyMessage = "No negative value allowed in closing balance";
                state.statusTag = "error";
            }
        },
        //function ivoke when claim id is selected in patient payment 
        onHandleClaimIDChange: (state, actions) => {
            if (actions.payload.length > 0) {
                state.patientPostDetails.claimPK = actions.payload[0].id;
                state.selectClaim = actions.payload[0].name;
                state.masterClaims = [];
            } else {
                state.patientPostDetails.claimPK = actions.payload[0].id;
                state.selectClaim = actions.payload[0].name;
                state.masterClaims = [];
            }
        },

        //function ivoke when patient selection in patient post payment window
        onPatientDropDownSelectAction: (state, actions) => {
            let { patientSelected, patientAdvSearchData, selectPatient } = actions.payload;
            state.patientSelectedData = patientSelected;
            state.patientAdvanceSearchData = patientAdvSearchData;
            state.selectedPatient = selectPatient;
        },

        //function ivoke when patient procedure level details reset after changes done
        resetPatientProcedureDetails: (state, actions) => {
            const { id, index, item } = actions.payload;
            const { patientClaims } = current(state)
            const { custom_claim_id } = item;
            let data = patientClaims[custom_claim_id].duplicate_procedures[index];
            state.procedureData[id] = data;
        },

        setOpenedClaimId: (state, action) => {
            state.openedClaimId = action.payload;
        },
        resetOpenedClaimId: (state) => {
            state.openedClaimId = [];
        },
        setShowDeleteModal: (state, action) => {
            const { value, id, cust_claim_id } = action.payload
            state.claimDeleteModal = value;
            state.custom_claim_id = cust_claim_id;
            state.selectedId = id;
        },
        //reset all state
        resetToInitialState: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(searchPayerList.pending, (state) => {
            state.payerListLoading = true;
        })
        builder.addCase(searchPayerList.rejected, (state) => {
            state.payerListLoading = false;
            state.notifyMessage = "Error while fetching payer list";
            state.statusTag = "error";
        })
        builder.addCase(searchPayerList.fulfilled, (state, actions) => {
            state.payerListLoading = false;
            if (actions.payload.length > 0) {
                state.payersList = actions.payload || [];
            } else {
                state.payerListLoading = false;
                state.payersList = [];
            }
        })

        builder.addCase(fetchPayments.pending, (state) => {
            state.paymentPostLoading = true;
        })
        builder.addCase(fetchPayments.rejected, (state,actions) => {
            let {message}=actions.payload
            state.paymentPostLoading = false;
            state.notifyMessage = message ? message :"Error while payment list";
            state.statusTag = "error";
        })

        builder.addCase(fetchPayments.fulfilled, (state, actions) => {
            state.paymentPostLoading = false;
            const { data } = actions.payload;
            state.table.payments = data.results;
            state.table.totalPage = Math.ceil(data.count / data.page_size);
        })

        builder.addCase(getpatientClaimList.pending, (state) => {
            state.payerListLoading = true;
        })
        builder.addCase(getpatientClaimList.rejected, (state) => {
            state.payerListLoading = false;
            state.notifyMessage = "Error while fetching claim list";
            state.statusTag = "error";
        })
        builder.addCase(getpatientClaimList.fulfilled, (state, actions) => {
            state.payerListLoading = false;
            if (actions.payload.length > 0) {
                state.masterClaims = actions.payload || [];
            } else {
                state.payerListLoading = false;
                state.masterClaims = [];
            }
        })

        builder.addCase(GetAdjustmentTypes.fulfilled, (state, actions) => {
            if (actions.payload.length > 0) {
                state.adjustmentTypes = actions.payload || [];
            } else {
                state.adjustmentTypes = [];
            }
        })

        builder.addCase(getClaimStatusAndSubStatus.fulfilled, (state, actions) => {
            const {
                claimStatusList,
                claimSubStatusList
            } = actions.payload;

            state.claimStatusList = claimStatusList;
            state.claimSubStatusList = claimSubStatusList
        })

        builder.addCase(getAdjustmentCodeList.fulfilled, (state, actions) => {
            if (actions.payload.data.length > 0) {
                const codeList = actions.payload.data.filter(
                    (item) =>
                        !(Object.prototype.hasOwnProperty.call(item, "label") && /^\d+$/.test(item.label))
                )
                if (actions.payload.field == "adjustment1") {
                    state.adjustment_1_codes_list = codeList || [];
                } else {
                    state.adjustment_2_codes_list = codeList || [];
                }
            } else {
                if (actions.payload.field == "adjustment1") {
                    state.adjustment_1_codes_list = [];
                } else {
                    state.adjustment_2_codes_list = [];
                }
            }
        })

        builder.addCase(postPaymentManually.fulfilled, (state) => {
            state.paymentPostLoading = false;
        })

        builder.addCase(onSavePayment.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(onSavePayment.rejected, (state) => {
            state.paymentPostLoading = false;
        })

        builder.addCase(onSavePayment.fulfilled, (state, action) => {            
            state.paymentPostLoading = false;
            if (action.payload.status == "201") {
                state.showNotification = true;
                state.notifyMessage = i18n.t("successMessages.payment_posted");
                state.statusTag = "success";
                state.postPaymentDetails.paymentPK = action.payload.data.id;
                state.clickedFromTable = true;
            } else if (action.payload.status === 500 || action.payload.status === 400) {
                state.showNotification = true;
                state.notifyMessage = action.payload.data.message == "reference_check_number_unique" ?
                    i18n.t("payments.post_payments.insurancePayment.paymenMessages.checkNumberUnique") : i18n.t("errorMessages.payment_error");
                state.statusTag = "error";
            }
        })

        builder.addCase(onSavePatientPayment.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(onSavePatientPayment.rejected, (state) => {
            state.paymentPostLoading = false;
        })

        builder.addCase(onSavePatientPayment.fulfilled, (state, actions) => {
            state.paymentPostLoading = false;
            if (actions.payload.postType === 3) {
                window.location.reload();
            }

            if (actions.payload.status === 200 || actions.payload.status === 201) {
                state.showNotification = true;
                state.notifyMessage = i18n.t("successMessages.payment_posted");
                state.statusTag = "success";
                state.postPaymentDetails.paymentPK = actions.payload.data.payment_pk;
                state.postPaymentDetails.patientPaymentPatientPK = actions.payload.data.patient_pk;
                state.postPaymentDetails.patientPaymentPostType = actions.payload.data.post_type
            }
            else if (actions.payload.status === 500) {
                state.showNotification = true;
                state.notifyMessage = i18n.t("errorMessages.payment_error");
                state.statusTag = "success";
            }
        })

        builder.addCase(getPaymentDetails.pending, (state) => {
            state.getPaymentDetailsLoading = true;
            state.isEditButtondisable = true;
        })

        builder.addCase(getPaymentDetails.rejected, (state) => {
            state.getPaymentDetailsLoading = false;
            state.isEditButtondisable = true;
        })

        builder.addCase(getPaymentDetails.fulfilled, (state, actions) => {
            state.getPaymentDetailsLoading = false;
            state.clickedFromTable = false;
            if (actions.payload) {
                let data = {
                    ...actions.payload,
                    unAppliedAmount: actions.payload["unapplied"] ?? 0,
                    appliedAmount: actions.payload["applied"] ?? 0,
                    payer: actions.payload.era_payer ? actions.payload.era_payer : actions.payload.payer
                }
                state.editPaymentVariables = {
                    ...actions.payload,
                    payer: actions.payload.era_payer ? actions.payload.era_payer : actions.payload.payer
                }
                state.isEditButtondisable = false;
                let selectedPayers = [{
                    "id": actions.payload.payer,
                    "name": actions.payload.payer_name,
                    "alert": ""
                }]

                state.selectedPayer = selectedPayers;
                state.insurancePaymentData = data;
            }
        })

        builder.addCase(getPatientPaymentData.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(getPatientPaymentData.rejected, (state) => {
            state.paymentPostLoading = false;
        })

        builder.addCase(getPatientPaymentData.fulfilled, (state, actions) => {
            let patientPostDetails = current(state).patientPostDetails
            state.paymentPostLoading = false;
            if (actions.payload.data) {
                state.patientPostDetails.patientId = actions.payload.data.patient_id;
                let { sumApplied, alreadyApplied, unApplied } = getSumAppliedUnApplied(actions.payload.data, patientPostDetails,actions.payload.action);
                let data = {
                    ...state.patientPostDetails,
                    unAppliedAmount: unApplied,
                    sumApplied: sumApplied,
                    alreadyApplied: alreadyApplied
                }
                state.patientPostDetails = data;
                state.patientPaymentData = actions.payload.data;
                state.patientPostDetails.paymentBalnceAmount = actions.payload.data.balance_amount;
                state.patientPostDetails.payment_amount = actions.payload.data.amount;
                state.editPaymentVariables = actions.payload.data;
                if (!actions.payload.updatePayment) {
                    let data = {
                        ...state.patientPostDetails,
                        showContinuePosting: true,
                        showPreview: true
                    }

                    state.patientPostDetails = data;
                }
            }
        })

        builder.addCase(checkForAlert.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(checkForAlert.rejected, (state) => {
            state.paymentPostLoading = false;
        })

        builder.addCase(checkForAlert.fulfilled, (state, actions) => {
            if (actions.payload.has_alert) {
                state.showAlertMessage = true;
                state.alertMessage = actions?.payload?.alert_message ? actions?.payload?.alert_message : ""
            }
        })

        builder.addCase(handleDeleteclaim.pending, (state) => {
            state.getPaymentDetailsLoading = true;
        })

        builder.addCase(handleDeleteclaim.fulfilled, (state, actions) => {
            state.getPaymentDetailsLoading = false;
                let {insurancePaymentData, claimList} = current(state);
                let updatedList = claimList?.filter(item => item?.claim_payment_info_id !== actions.payload?.id)
                state.claimList = updatedList;
                let updatedAmount = actions.payload?.response?.insurance_payment;
                state.insurancePaymentData = {
                    ...insurancePaymentData,
                    appliedAmount: updatedAmount.applied,
                    unAppliedAmount: updatedAmount.unapplied
                }
                state.claimDeleteModal = false;
                state.showNotification = true;
                state.notifyMessage = i18n.t("payments.post_payments.insurancePayment.paymenMessages.claimDeleted");
                state.statusTag = "success";
        })

        builder.addCase(handleDeleteclaim.rejected, (state,actions) => {
            state.getPaymentDetailsLoading = false;
            if (actions.payload) {
                state.showNotification = true;
                state.notifyMessage = actions.payload.message;
                state.statusTag = actions.payload.type;
                state.claimDeleteModal = false;
            }
        })    

        builder.addCase(searchClaimIDS.fulfilled, (state, actions) => {
            state.masterClaims = actions.payload.data;
        })

        builder.addCase(listPatientDropdownData.fulfilled, (state, actions) => {
            state.patientDropdown = actions.payload;
        })

        builder.addCase(listPatientClaims.pending, (state) => {
            state.searchClaimLoading = true;
        })

        builder.addCase(listPatientClaims.rejected, (state) => {
            state.searchClaimLoading = false;
        })

        builder.addCase(listPatientClaims.fulfilled, (state, actions) => {
            state.searchClaimLoading = false;
            if (actions.payload.results.length) {
                state.searchModalOpen = true;
                state.patientClaimsData = actions.payload?.results;
                state.header = i18n.t("payments.post_payments.insurancePayment.searchResults");
            }
        })

        builder.addCase(listProcedureClaims.pending, (state) => {
            state.searchClaimLoading = true;
        })

        builder.addCase(listProcedureClaims.rejected, (state, actions) => {
            state.searchClaimLoading = false;
            state.showNotification = true;
            state.notifyMessage = actions?.payload?.message || "An error occurred";
            state.statusTag = "error";
        })
        builder.addCase(listProcedureClaims.fulfilled, (state, actions) => {            
            state.searchClaimLoading = false;
            state.openClaimWindow = true;
            let { jsonObject, oldResponsibilityObject,responsibility_type } = createProcedureData(actions.payload.data) || {};
            state.procedureData = jsonObject;
            state.oldResponsibility = oldResponsibilityObject;
            state.claimIdOpened = actions.payload?.data[0]?.custom_claim_id ?? actions.payload?.openedId;
            state.claimPK=actions.payload.claimPK ?? ""
            state.responsibility_type = responsibility_type;
            state.is_manually_added_claim = actions.payload?.is_manually_added;
        })

        builder.addCase(getPatientPaymentClaimDetails.pending, (state) => {
            state.dataLoading = true;
        })

        builder.addCase(getPatientPaymentClaimDetails.rejected, (state) => {
            state.dataLoading = false;
        })

        builder.addCase(getPatientPaymentClaimDetails.fulfilled, (state, actions) => {
            state.dataLoading = false;
            let jsonObject = createJsonDataPatientPayment(actions.payload);
            state.patientClaims = { ...state.patientClaims, ...jsonObject };
        })

        builder.addCase(getPatientPaidClaims.pending, (state) => {
            state.dataLoading = true;
        })

        builder.addCase(getPatientPaidClaims.rejected, (state) => {
            state.dataLoading = false;
        })

        builder.addCase(getPatientPaidClaims.fulfilled, (state, actions) => {
            state.dataLoading = false;
            let jsonObject = createJsonDataPatientPayment(actions.payload);
            state.patientClaims = { ...state.patientClaims, ...jsonObject };
        })

        builder.addCase(openProcedureModalWindow.pending, (state) => {
            state.savedProcedureLoading = true;
        })

        builder.addCase(openProcedureModalWindow.rejected, (state) => {
            state.savedProcedureLoading = false;
        })

        builder.addCase(openProcedureModalWindow.fulfilled, (state, actions) => {
            let responseData = actions.payload?.result;
            let claimPaymentInfoId = actions.payload.claim_payment_info_id
            if (responseData?.status === 404 && responseData.message == "claim_pk_not_found" ){
                state.showNotification = true;
                state.notifyMessage = i18n.t("payments.post_payments.insurancePayment.paymenMessages.claimIdNotFound");
                state.statusTag = "error";
                state.savedProcedureLoading = false;
                return;
            }
            
            state.savedProcedureLoading = false;
            if(responseData.data.length>0){
            state.openClaimWindow=true;
            state.is_manually_added_claim=false;
            
                let { jsonObject, oldResponsibilityObject, responsibility_type } = createProcedureData(responseData.data, claimPaymentInfoId);

            state.procedureData = jsonObject;
            state.duplicate_procedureData=jsonObject;
            state.oldResponsibility = oldResponsibilityObject;
            state.claimIdOpened = actions.payload.customId;
                state.claimPaymentInfoIdOpened = actions.payload.claim_payment_info_id;
            state.claimPK=actions.payload.claimPK;
            state.responsibility_type = responsibility_type;
            }
        })

        builder.addCase(listInsurancePaymentData.pending, (state) => {
            state.dataLoading = true;
        })

        builder.addCase(listInsurancePaymentData.fulfilled, (state, action) => {
            state.dataLoading = false;
            if (action.payload.action === "get") {
                state.claimList = action.payload.data;
            }
        })

        builder.addCase(listInsurancePaymentData.rejected, (state) => {
            state.dataLoading = false
        })

        builder.addCase(handleProcedureSubmit.pending, (state) => {
            state.saveProcedureLoading = true;
        })

        builder.addCase(handleProcedureSubmit.rejected, (state, action) => {
            state.saveProcedureLoading = false;
            if (action.payload.flag == "validation_error") {
                state.validationError = action.payload.validationError;
                state.validationErrorModal = true;
            } else {
                const message = action.payload?.message;
                const statusTag = action.payload?.statusTag;

                if (message === "No data changes to save") {
                    state.openClaimWindow = false;
                    state.showNotification = false;
                    return;
                }

                state.showNotification = true;
                state.statusTag = statusTag;
                state.notifyMessage = message || "An error occurred";
            }

        });
        builder.addCase(handleProcedureSubmit.fulfilled, (state, actions) => {  
            state.saveProcedureLoading = false;
                const {insurancePaymentData, claimList} = current(state);
                state.showNotification = true;
                state.notifyMessage = "Payment Updated...";
                state.statusTag = "success";
                state.saveTriggered = true;
                state.openClaimWindow = false;
                state.procedureData = {};
                const updatedClaim = actions.payload.data?.insurance_payment_claim[0];
                
                // Find the index of the claim if it already exists
                const existingIndex = claimList?.findIndex(
                    (claim) => claim.claim_payment_info_id === updatedClaim.claim_payment_info_id
                );

                if (existingIndex !== -1) {
                    // If it exists, update it
                    state.claimList[existingIndex] = {
                        ...state.claimList[existingIndex],
                        ...updatedClaim,
                    };
                } else {
                    // If it doesn't exist, add it
                    state.claimList.push(updatedClaim);
                }

                let updatedAmount = actions.payload.data?.insurance_payment;
                state.insurancePaymentData = {
                    ...insurancePaymentData,
                    appliedAmount: updatedAmount.applied,
                    unAppliedAmount: updatedAmount.unapplied
                }
                state.procedureError = initialState.procedureError;
                state.oldResponsibility = initialState.oldResponsibility;
                state.responsibility_type = initialState.responsibility_type;
                state.claimIdOpened = "";
            state.claimPaymentInfoIdOpened = "";
                state.is_manually_added_claim = false;
        })
        builder.addCase(GetPatientPaymentPlans.fulfilled, (state, actions) => {
            if (actions.payload.payment_plan != "") {
                state.paymentPlanList = actions.payload.payment_plan ? actions.payload.payment_plan : [];
                state.paymentPlan_status = true;
            }
            else {
                state.paymentPlan_status = false;
            }
        })

        builder.addCase(CheckForPaymentExists.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(CheckForPaymentExists.fulfilled, (state, actions) => {
            state.paymentPostLoading = false;
            if (actions.payload.data.payment_exists) {
                state.alertMessage = "Payment Already Exists";
                state.showAlertMessage = true;
            } else if (actions.payload.postType == "credit") {
                state.showPostAsCreditModal = true;
                state.header = i18n.t("payments.post_payments.postAsCreditModalHeader")
            } else {
                if (actions.payload.postType === "manually") {
                    if (!state.patientPostDetails.postManually) {
                        //CHECK ALL MANDATORY FIELDS ARE FILLED
                        let data = {
                            ...state.patientPostDetails,
                            postManually: !state.patientPostDetails.postManually,
                            autoPost: false
                        }
                        state.patientPostDetails = data;
                    } else {
                        let data = {
                            ...state.patientPostDetails,
                            postManually: !state.patientPostDetails.postManually,
                            autoPost: false
                        }
                        state.patientPostDetails = data;
                    }
                } else {
                    if (!state.patientPostDetails.autoPost) {
                        //CHECK ALL MANDATORY FIELDS ARE FILLED
                        let data = {
                            ...state.patientPostDetails,
                            postManually: false,
                            autoPost: !state.patientPostDetails.autoPost
                        }
                        state.patientPostDetails = data;
                    } else {
                        let data = {
                            ...state.patientPostDetails,
                            postManually: false,
                            autoPost: !state.patientPostDetails.autoPost
                        }
                        state.patientPostDetails = data;
                    }
                }
            }
        })

        builder.addCase(CheckForPaymentExists.rejected, (state, actions) => {
            state.showNotification = true;
            state.notifyMessage = actions.payload.message;
            state.statusTag = actions.payload.tag;
            state.paymentPostLoading = false;
        })

        builder.addCase(getResponibilityTypePatient.fulfilled, (state, actions) => {
            state.responsibilityData = actions.payload.responsibility_list;
        })

        builder.addCase(ListPatientAppliedClaims.pending, (state) => {
            state.dataLoading = true;
        })

        builder.addCase(ListPatientAppliedClaims.rejected, (state) => {
            state.dataLoading = false;
        })

        builder.addCase(ListPatientAppliedClaims.fulfilled, (state, actions) => {
            state.patientAppliedProcedures = actions.payload;
            state.patientPostDetails.showContinuePosting = false;
            state.patientPostDetails.showAppliedPayments = true;
        })

        builder.addCase(handleRadioButtonChange.fulfilled, (state, action) => {
            const { radioValue, result } = action.payload;
            const { claimStatusList } = current(state);
            state.patientPostDetails.radioValue = radioValue;
            let amountToApply = Number(state.patientPaymentData.amount);
            let claimStatus = claimStatusList.filter(
                (item) => item.name.toLowerCase() === "claim paid"
            );

            let claimSubStatusList = claimStatus.length > 0 ? claimStatus : [];
            let claimSubStatus = claimSubStatusList[0]?.sub_status?.filter(
                (item) => item.name.toLowerCase() === "paid"
            ) || [];

            result.forEach((item) => {
                state.patientClaims[item].procedures = current(state.patientClaims[item].procedures).map((procedure) => {
                    let procedureOpeningBalance = parseFloat(procedure.opening_balance).toFixed(2);
                    let updatedProcedure;

                    if (procedureOpeningBalance >= amountToApply) {
                        updatedProcedure = {
                            ...procedure,
                            apply_payment: parseFloat(amountToApply).toFixed(2),
                            responsibility_type: 4,
                            closing_balance: procedure.opening_balance - amountToApply,
                            claim_status_id: null,
                            claim_sub_status_id: null
                        };
                        amountToApply = 0;
                    } else {
                        updatedProcedure = {
                            ...procedure,
                            apply_payment: parseFloat(procedureOpeningBalance).toFixed(2),
                            responsibility_type: 5,
                            closing_balance: 0.00,
                            claim_status_id: claimStatus[0].id ? claimStatus[0].id : null,
                            claim_sub_status_id: claimSubStatus[0].id ? claimSubStatus[0].id : null
                        };
                        amountToApply -= procedureOpeningBalance;
                    }

                    return updatedProcedure;
                });
            });
        });
        builder.addCase(handleRadioButtonChange.rejected, (state, action) => {
            state.showNotification = true;
            state.notifyMessage = action.error.message || "An error occurred";
            state.statusTag = "error";
        });


        builder.addCase(onSavePatientPaymentProcedure.pending, (state) => {
            state.paymentPostLoading = true;
        })

        builder.addCase(onSavePatientPaymentProcedure.fulfilled, (state, actions) => {
            state.paymentPostLoading = false;
            if (actions.payload.status == 200) {
                state.showNotification = true;
                state.notifyMessage = "Payment Updated...";
                state.statusTag = "success";
                if (state.patientPaymentVariables.PrintReceiptonsaving || state.patientPostDetails.PrintReceiptonsaving) {
                    setStorage("paymentPK", actions.payload.pk);
                    state.redirectToReceipt = true;
                }
                state.patientClaimRemoved = false;
                state.saveTriggered = true;
            } else {
                if (actions.payload.data?.message === 'invalid_responsibility_type') {
                    state.showNotification = true;
                    state.notifyMessage = `Claim status selected not matching with the Priority on Procedure ${actions.payload?.data?.data?.cpt ?? ""}`;
                    state.statusTag = "error";
                }

                if (actions.payload.data?.message === 'cpt_or_claim_status_missing') {
                    state.showNotification = true;
                    state.notifyMessage = `Procedure or the claim status is missing in a procedure row.`;
                    state.statusTag = "error";
                }
            }
        })

        builder.addCase(onSavePatientPaymentProcedure.rejected, (state, actions) => {
            state.paymentPostLoading = false;
            if (actions.payload.action === "error") {
                state.showNotification = true;
                state.notifyMessage = actions.payload.message;
                state.statusTag = "error";
            }

            if (actions.payload.action === "validation_error") {
                state.validationError = actions.payload.message;
                state.validationErrorModal = true;
            }

            if (actions.payload.action === "alert") {
                state.alertMessage = actions.payload.message;
                state.showAlertMessage = true;
            }
        })

        builder.addCase(reverseInsurancePaymentProcedure.pending, (state, actions) => {
            state.reverseLoading = true;
            let { procedureData } = current(state);
            const { index } = actions.meta.arg;
            let reverseIndex = index + 1;
            const skeletonId = [`New-${crypto?.randomUUID()}`];
            const skeletonClaim = { isSkeleton: true,skeltonId:"skelton" };
            // Insert skeleton in 2nd position
            const entries = Object.entries(procedureData);
            entries.splice(reverseIndex, 0, [skeletonId, skeletonClaim]);
            const newDataWithSkeleton = Object.fromEntries(entries);
            state.procedureData = newDataWithSkeleton;

        })

        builder.addCase(reverseInsurancePaymentProcedure.rejected, (state,action) => {
            state.reverseLoading = false;
            state.showNotification = true;
            state.notifyMessage = action.payload.message || "An error occurred";
            state.statusTag = "error";
            for (const key in state.procedureData) {
                if (state.procedureData[key]?.skeltonId === 'skelton') {
                    delete state.procedureData[key];
                    break;
                }
            }
            
        })

        builder.addCase(reverseInsurancePaymentProcedure.fulfilled, (state, actions) => {
            let {id,revexIndex,claim_data,procedure_data,insurance_payment}=actions.payload;
            let {procedureData,claimList,insurancePaymentData,responsibility_type}=current(state);
            state.reverseLoading=false;
            const claim_payment_info_id = claim_data[0].claim_payment_info_id;
            state.procedureData[id].entry_reversed = true;
            /**
             * changing original procedure data and duplicate with new data
             */
            const { jsonObject } = createProcedureData([procedure_data], claim_payment_info_id);
            const newDataEntry = Object.entries(jsonObject)[0];
            const [, newValue] = newDataEntry;

            // Find the key with skeltonId === "skelton"
            const skeletonKey = Object.keys(state.procedureData).find(
                key => state.procedureData[key].skeltonId === 'skelton'
            );

            if (skeletonKey) {
                // Replace the skeleton with the new entry
                state.procedureData[skeletonKey] = {
                    ...newValue,
                    skeltonId: ""
                };
            }
            state.duplicate_procedureData=state.procedureData;

            // // function to update old responsibility type and responsibility type

            const newResponsibilityEntry=insertAtPosition(responsibility_type,revexIndex,newValue.responsibility_type ?? "");
            state.oldResponsibility=newResponsibilityEntry;
            state.responsibility_type=newResponsibilityEntry;

            const updatedClaim = claim_data.length>0 ? claim_data[0] : {};

            // Find the index of the claim if it already exists
            const existingIndex = claimList?.findIndex(
                (claim) => claim.claim_payment_info_id === claim_payment_info_id
            );

            if (existingIndex !== -1) {
                // If it exists, update it
                state.claimList[existingIndex] = {
                    ...state.claimList[existingIndex],
                    ...updatedClaim 
                };
            } else {
                // If it doesn't exist, add it
                state.claimList.push(updatedClaim);
            }

                state.insurancePaymentData = {
                    ...insurancePaymentData,
                    appliedAmount: insurance_payment?.applied ?? "",
                    unAppliedAmount: insurance_payment?.unapplied ?? ""
                }


                state.showNotification = true;
                state.notifyMessage = `Procedure: ${procedureData[id]?.procedure} successfully reversed`;
                state.statusTag = "success";
        })

        
        builder.addCase(DeleteProcedureDataFromModal.pending, (state) => {
            state.saveProcedureLoading = true;
        })

        builder.addCase(DeleteProcedureDataFromModal.fulfilled, (state, actions) => {
            const { response, id } = actions.payload;
            const { insurance_payment_claim, insurance_payment } = response;

            const { insurancePaymentData, claimList, procedureData } = current(state);
            delete state.procedureData[id];
            delete state.duplicate_procedureData[id];

            state.insurancePaymentData = {
                ...insurancePaymentData,
                appliedAmount: insurance_payment.applied,
                unAppliedAmount: insurance_payment.unapplied
            }

            const updatedClaim = insurance_payment_claim?.[0];

            if (updatedClaim) {
                // Find the index of the claim if it already exists
                const existingIndex = claimList?.findIndex(
                    (claim) => claim.claim_payment_info_id === updatedClaim.claim_payment_info_id
                );

                if (existingIndex !== -1) {
                    // If it exists, update it
                    state.claimList[existingIndex] = {
                        ...state.claimList[existingIndex],
                        ...updatedClaim,
                    };
                } else {
                    // If it doesn't exist, add it
                    state.claimList.push(updatedClaim);
                }

            } else {
                // when all no procedures found in the claim after this delete
                const updatedClaimList = claimList.filter((claim) => claim.claim_payment_info_id !== procedureData[id].claimPaymentInfoId);
                state.claimList = updatedClaimList;
                state.openClaimWindow = false;
                state.procedureData = {};
                state.duplicate_procedureData = {};
                state.procedureError = initialState.procedureError;
                state.oldResponsibility = initialState.oldResponsibility;
                state.responsibility_type = initialState.responsibility_type;
                state.claimIdOpened = "";
                state.claimPaymentInfoIdOpened = "";
            }

            state.saveProcedureLoading = false;
            state.showNotification = true;
            state.notifyMessage = `Procedure: ${procedureData[id]?.procedure} successfully deleted from claim id: ${procedureData[id]?.custom_claim_id}`;
            state.statusTag = "success";
        })

        builder.addCase(DeleteProcedureDataFromModal.rejected, (state, actions) => {
            state.saveProcedureLoading = false;
            if (actions.payload) {
                state.showNotification = true;
                state.notifyMessage = actions.payload.message;
                state.statusTag = actions.payload.type;
            }
        })

        builder.addCase(fetchFiltersData.fulfilled, (state, actions) => {
            state.lists = actions.payload;
        })
    }

});

export const { setPostPaymentType, updatePayerDetails, resetNotifyWindow, updateDate, updateValueChange, validationErrorShowing, onContinuePosting, onHandleClaimIDChange,
    resetPaymentDetails, showNotification, resetAlertMessage, showAlertMessage, showLoadingBar, showModalWindow, hideModalWindow,setPaginationChange,
    storePaymentDetailsTableClick, updateClaimSearchVariables, procedureValueChange, addAdjustmentCode1, removeAdjustmentCode, addAdjustmentAmount, resetSearchVariable,
    addAdjustmentCode2, onAddRemarkCodes, openClaimModalWindow, handleProcedureEditWindowClose, onFieldBlurApply, removeAllPaymentDetails, updateQueryDetails,
    onHandleSearchClaimDateChange, onHandleValueChange, onHandleEditPayment, onHandleEditPaymentDate,updateFilters,setEditPayment,resetFilters,clearEditPayment,
    removeAdjustmentCodeList, onHandleAdvanceSearchFields, setFormError, setPatientPostDetails, onChangePostPaymentType, onHandleApplyPaient, openPatientModalWindow,
    handlePatientTableDataUpdate, onPatientDropDownSelectAction, resetPatientProcedureDetails, resetToInitialState, removePatientClaimFromTable, resetPatientDropdownSearch, setOpenedClaimId,
    resetOpenedClaimId, movedToCreditValueChange, setToggleState, setShowDeleteModal, onAlertModal, RemoveProcedureDataManually
} = paymentSlice.actions;

export default paymentSlice.reducer;